import './style.scss'
import './js/sections/index.js'
import './js/globals/index.js'

const transparentHeader =  document.querySelector('.mksun-layout-header--transparent')
if(transparentHeader){
    window.addEventListener('scroll', () => {
        if(window.scrollY > 100){
            transparentHeader.classList.add('mksun-layout-header--scrolled')
        } else {
            transparentHeader.classList.remove('mksun-layout-header--scrolled')
        }
    })
}